import useFetchService from '@/composables/useFetchService';

import type { BootstrapResponse } from '@/types/api/bootstrap';

export default function useBootstrapService() {
  /********************
   * COMPOSITIONS      *
   ********************/
  const runtimeConfig = useRuntimeConfig();
  const fetchService = useFetchService({ base: runtimeConfig.public.apiUrl, version: 3 });

  /********************
   * FUNCTIONS         *
   ********************/
  function getBootstrap(lang: string): Promise<BootstrapResponse> {
    return fetchService.get('/bootstrap/', lang);
  }

  return {
    getBootstrap,
  };
}
